// src/context/AuthContext.js
import React, { createContext, useState } from "react";
import { useNavigate } from "react-router-dom";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();

  /* ───────────────────────── Utilidades localStorage ───────────────────────── */
  const cleanLocalStorage = () => {
    // Valores mal guardados como "undefined"
    if (localStorage.getItem("user") === "undefined")
      localStorage.removeItem("user");
    if (localStorage.getItem("tokenTipoP") === "undefined")
      localStorage.removeItem("tokenTipoP");
    if (localStorage.getItem("password") === "undefined")
      localStorage.removeItem("password");

    // Limpieza de la antigua clave "token" si aún existe
    if (localStorage.getItem("token") === "undefined")
      localStorage.removeItem("token");
  };
  cleanLocalStorage();

  const getStoredUser = () => {
    try {
      const raw = localStorage.getItem("user");
      return raw && raw !== "undefined" ? JSON.parse(raw) : null;
    } catch {
      localStorage.removeItem("user");
      return null;
    }
  };

  const [user, setUser] = useState(getStoredUser());
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!(
      (
        (localStorage.getItem("tokenTipoP") &&
          localStorage.getItem("tokenTipoP") !== "undefined") ||
        (localStorage.getItem("token") &&
          localStorage.getItem("token") !== "undefined")
      ) // compat.
    )
  );

  /* ──────────────────────────── LOGIN ──────────────────────────── */
  // Se llama como login(telefono, password, idNutriologo)
  const login = async (telefono, password, idNutriologo) => {
    try {
      if (!idNutriologo) {
        return { success: false, message: "Falta idNutriologo." };
      }

      const res = await fetch("/api/paciente/auth", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ telefono, password, idNutriologo }),
      });
      const data = await res.json();

      if (!res.ok) {
        return {
          success: false,
          message: data.message || "Error al iniciar sesión",
        };
      }

      const info = data.data; // { user, token, paciente }
      if (!info) {
        return { success: false, message: "Respuesta incompleta del backend." };
      }

      const userData = {
        ...info.user,
        token: info.token,
        paciente: info.paciente,
        password,
        idNutriologo,
      };

      localStorage.setItem("user", JSON.stringify(userData));
      localStorage.setItem("tokenTipoP", info.token);
      localStorage.setItem("password", password);

      // Borra la clave vieja "token" si quedó de implementaciones previas
      localStorage.removeItem("token");

      setUser(userData);
      setIsAuthenticated(true);
      navigate("/miperfil");
      return { success: true };
    } catch {
      return {
        success: false,
        message: "Error inesperado, intenta nuevamente.",
      };
    }
  };

  /* ──────────────────────────── LOGOUT ──────────────────────────── */
  const logout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("tokenTipoP");
    localStorage.removeItem("password");
    localStorage.removeItem("token"); // compat. vieja clave
    setUser(null);
    setIsAuthenticated(false);
    navigate("/perfil");
  };

  /* ──────────────────────────── PROVIDER ──────────────────────────── */
  return (
    <AuthContext.Provider value={{ isAuthenticated, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
